module.exports = __webpack_public_path__ + "static/media/5.51b2f33b.png";